import { Button } from '@boltenergy-be/design-system'
import { startSimulationOrRegistration } from 'utils/customerFlow'
import { useTranslation } from 'next-i18next/pages'
import { StartSimulationButtonProps } from './types'
import { useRouter } from 'next/router'

const StartSimulationButton = ({
  text,
  extraOnClickAction,
  variant,
  isFullwidthMobile,
  isFullwidth,
  className,
  trailingIcon = 'chevronRight',
  ...startProps
}: StartSimulationButtonProps) => {
  // i18n
  const { t } = useTranslation()

  // Router
  const { pathname } = useRouter()

  // Constants
  const buttonProps = { variant, isFullwidthMobile, className, isFullwidth }

  return (
    <Button
      {...buttonProps}
      type="button"
      trailingIcon={trailingIcon !== 'none' ? trailingIcon : undefined}
      onClick={() => {
        extraOnClickAction?.()
        void startSimulationOrRegistration({ ...startProps, fromPage: startProps.fromPage || pathname })
      }}
    >
      {text || t('calculateProposal')}
    </Button>
  )
}

export default StartSimulationButton
